import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Company, Entity } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of, tap } from 'rxjs';

export const CUSTOM_LOGO_ID = "CUSTOM_LOGO";

@Component({
    selector: 'company-logo-picker',
    templateUrl: './company.logo.picker.component.html',
    styleUrls: ['./company.logo.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: CompanyLogoPickerComponent, multi: true }
    ],
    standalone: false
})
export class CompanyLogoPickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: Partial<Company>[];
  @Input() public placeholder = '<Company>';
  @Input() public appendTo;
  @Input() public multiple: boolean;
  @Input() public clearable = true;

  public data$: Observable<Partial<Company>[]>;
  public PickerItemStyle = PickerItemStyle;

  private readonly CUSTOM_OPTION: Entity = {
    _id: CUSTOM_LOGO_ID,
    name: '<Custom>',
    active: true,
  }

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges() {

    const data$ = this.fetch === PickerFetch.Automatic
      ? this.getData()
      : of(this.data);

    this.data$ = data$.pipe(tap(x => x.push(this.CUSTOM_OPTION)))

  }

  private getData(): Observable<Partial<Company>[]> {
    return this.http.get<Partial<Company>[]>('/api/picker/company/logos');
  }
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule
  ],
  declarations: [
    CompanyLogoPickerComponent
  ],
  providers: [],
  exports: [
    CompanyLogoPickerComponent
  ],
})
export class CompanyLogoPickerModule { }
